module.exports = __webpack_public_path__ + "assets/img/DB-Results-Service-Page.ee9c88f6.jpg";